import DisconnectedWarning from './DisconnectedWarning';
import { useSession } from '../Context';
const Ready = ({ children }) => {
  const {
    cable: { online },
  } = useSession();
  return (
    <>
      {!online && <DisconnectedWarning />}
      {children}
    </>
  );
};

export default Ready;
